export const Download = {
  methods: {
    showWarning() {
      if (document.querySelector('.download-warning')) {
        document.querySelector('.download-warning').classList.add('show');
        setTimeout(() => {
          document.querySelector('.download-warning').classList.remove('show');
        }, 15000);
      }
    },
  },
};
